<template>
<v-menu class="title-topbar" v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-y content-class="topbar-menu-list">
    <template v-slot:activator="{ on }">
        <v-btn text dark v-on="on" :class="['text-capitalize hotel-title', $vuetify.breakpoint.xs?'pa-0':'']" :ripple='false' @click="focusSelection()">
            <span v-if="hotel.id">{{hotel.name}} <sup class="sup-hotel-id">{{hotel.id}}</sup></span>
            <span v-else>Select hotel</span>
        </v-btn>
    </template>
    <v-card :class="['search-results', menu?'':'d-none']">
        <v-autocomplete class="mt-0 pt-0" id="input-hotel" ref="hotel_selection" v-model="item" @input="changeMyHotel(item)" :loading="loading_hotels" return-object :items="items" :search-input.sync="search" append-icon="" item-text="name"
            item-value="id" placeholder="Start typing to Search" hide-details>
            <template v-slot:selection="data"></template>
            <template v-slot:item="data">
                <div class="d-flex align-center">
                    <div class="faded px-1">{{data.item.id}}</div>
                    <div>
                        <div class="regular">{{data.item.name}}</div>
                        <div class="faded">{{data.item.city}}</div>
                    </div>
                </div>
            </template>
        </v-autocomplete>
    </v-card>
</v-menu>
</template>

<script>
import {
    mapActions
} from 'vuex';

export default {
    props: {
        hotel: [Object, Promise],
    },
    name: 'App',

    data() {
        return {
            menu: false,
            search_timeout: 500,
            //hotel selection
            loading_hotels: false,
            search: null,
            items: [],
            item: {},
        }
    },

    watch: {
        search: {
            handler() {
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getItems(), 700);
            }
        },
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        changeMyHotel(value) {
            if(typeof value == 'undefined')
                return;
            this.$emit('changeHotel', value);
            this.menu = false;
            this.search = null;
        },

        getItems() {
            this.loading_hotels = true;
            // prepare search string
            let search = this.search;
            if(search === "" || search === undefined) {
                search = null;
                // return
            }

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/hotels';

            // setup query params
            let params = {
                params: {
                    size: 5,
                    query: search
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    this.items = response.data.data;
                })
                .catch(error => {
                    this.error('Ooops, something gone wrong');
                    console.log(error);
                })
                .finally(() => {
                    this.loading_hotels = false;
                });
        },

        focusSelection() {
            setTimeout(() => {
                this.getItems();
                document.getElementById("input-hotel")
                    .click();
            }, 100);
        }

    },


}
</script>
<style lang="stylus">
.sup-hotel-id
    font-size: 12px
    top: -1.2em
.hotel-title
    &.v-btn
        span
            font-size: 24px
            font-weight: 700
            @media only screen and (max-width: 700px)
                font-size: 18px
                font-weight: 700
                left: 0
            @media only screen and (max-width: 450px)
                    max-width: 140px
                    white-space: nowrap !important
                    overflow: hidden !important
                    text-overflow: ellipsis !important
                    line-height: 1.1 !important
</style>
